export default "__VITE_ASSET__BzNOsz0Z__"